// extracted by mini-css-extract-plugin
export default {"Modal":"Modal_Modal__jO2+n","Modal--Visible":"Modal_Modal--Visible__6mZAX","Big_modal_flex_inline":"Modal_Big_modal_flex_inline__VDRbp"};